import { render } from "./ProductsBySupplier.vue?vue&type=template&id=6052d4d4&scoped=true"
import script from "./ProductsBySupplier.vue?vue&type=script&lang=js"
export * from "./ProductsBySupplier.vue?vue&type=script&lang=js"

import "./ProductsBySupplier.vue?vue&type=style&index=0&id=6052d4d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6052d4d4"]])

export default __exports__